<template>
  <page class="">
    <div class="divIframe">
      <iframe class="iframe" src="https://docs.google.com/forms/d/e/1FAIpQLSesmJBQtGJZ2h11cm6rqMntsRsVvL9PdmY_aeUJiQmU8eO5EQ/viewform?embedded=true" width="640" height="1032" frameborder="0" marginheight="0" marginwidth="0">Carregando…</iframe>
    </div>
  </page>
</template>

<script>
import page from "./pageTemplate";

export default {
  components: {
    page
  },
  metaInfo: {
    title: "Feedback",
    meta: [
      {name: "robots", content: "noindex"},
      {name: "description", content: "Envie seu feedback para Chapstory!"},
      {rel: "canonical", href: "https://www.chapstory.com/feedback"}
    ]
  }
}
</script>
<style lang="scss" scoped>
.iframe{
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.iframe >>> div.freebirdSolidBackground{
  background-color: #30e3ca;
}

@media (max-height: 1024px) {
  .divIframe{
    height: 107%;
  }
  .iframe{
    height: 100%;
  }
}

@media (max-height: 823px) {
  .divIframe{
    height: 158%;
  }
}

@media (max-height: 736px) {
  .divIframe{
    height: 167%;
  }
}

@media (max-height: 667px) {
  .divIframe{
    height: 211%;
  }
}

@media (max-height: 568px) {
  .divIframe{
    height: 275%;
  }
}

@media (max-height: 414px) {
  .divIframe{
    height: 292%;
  }
}

@media (max-height: 375px) {
  .divIframe{
    height: 330%;
  }
}

@media (max-height: 375px) {
  .divIframe{
    height: 410%;
  }
}
</style>
